// extracted by mini-css-extract-plugin
export var contact = "footer-module--contact--IzlB5";
export var copyright = "footer-module--copyright--kPsoG";
export var footerButton = "footer-module--footerButton--EPvvX";
export var footerContainer = "footer-module--footerContainer--YZy+j";
export var footerHeading = "footer-module--footerHeading--yNhVp";
export var footerInfoContainer = "footer-module--footerInfoContainer--jMxtG";
export var footerLogo = "footer-module--footerLogo--DI73w";